import { render, staticRenderFns } from "./BirthdayModal.vue?vue&type=template&id=b524d926&scoped=true&"
import script from "./BirthdayModal.vue?vue&type=script&lang=js&"
export * from "./BirthdayModal.vue?vue&type=script&lang=js&"
import style0 from "./BirthdayModal.vue?vue&type=style&index=0&id=b524d926&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "b524d926",
  null
  
)

export default component.exports